import React, { lazy } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";

import SplachScreen from "../components/splachScreen";
import SplachScreenTeacher from "../components/splachScreenTeacher";
import SplachScreenStudent from "../components/splachScreenStudent";

import {
  PROTECTED,
  SEARCH_URL,
  STUENT_JOURNEY_URL,
  TEACHER_JOURNEY_URL,
  HOME_URL,
  Dynamo_URL,
  Blog_url,
  About_url,
  Privacy_url,
  Contact_url,
  ReturnRefund_url,
  Terms_url,
  PaymentFailed_url,
  PaymentSuccess_url,
  PaymentTest_url,
} from "../constants";

import Chat from "../components/chat/chat";
import Dynamo from "../pages/Dynamo";

// const StudentsJourneyAdvanceFilter = lazy(() =>
//   import("../pages/studentsJourneyAdvanceFilter")
// );

import StudentsJourneyAdvanceFilter from "../pages/studentsJourneyAdvanceFilter";
const StudentMessages = lazy(() => import("../pages/student/student-messages"));
const TeacherMessages = lazy(() =>
  import("../pages/teacherJourney/teacher-messages")
);
const TeacherMeetings = lazy(() =>
  import("../pages/teacherJourney/teacher-meetings")
);
const TeacherOffers = lazy(() =>
  import("../pages/teacherJourney/teacher-offers")
);
const TeachingBoard = lazy(() =>
  import("../pages/teacherJourney/teaching-board")
);
const StudentOffers = lazy(() => import("../pages/student/student-offers"));
const Home = lazy(() => import("../pages/Home/index.js"));
const NotFound = lazy(() => import("../pages/notFound"));
const UnAuthorized = lazy(() => import("../pages/unAuthorized"));
const StudentMyTeacher = lazy(() =>
  import("../pages/student/StudentMyTeacher")
);
const StudentSession = lazy(() => import("../pages/student/StudentSession"));
const StudentMeetings = lazy(() => import("../pages/student/student-meetings"));
const StudentProfileSetting = lazy(() =>
  import("../pages/student/StudentProfile")
);
const TeacherJourneyCourse = lazy(() =>
  import("../pages/teacherJourney/TeacherCourseNew")
);
const TeacherDocuments = lazy(() =>
  import("../pages/teacherJourney/teacher-documents")
);
const TeacherJourneyEducation = lazy(() =>
  import("../pages/teacherJourney/TeacherEducation")
);
const TeacherJourneyExperience = lazy(() =>
  import("../pages/teacherJourney/TeacherExperience")
);
const TeacherJourneyMode = lazy(() =>
  import("../pages/teacherJourney/TeacherModeofEducation")
);
const TeacherJourneyMemberShip = lazy(() =>
  import("../pages/teacherJourney/TeacherMembership/index.js")
);
const TeacherJourneySlots = lazy(() =>
  import("../pages/teacherJourney/TeacherSlots")
);
const TeacherJourneySchedule = lazy(() =>
  import("../pages/teacherJourney/TeacherSchedule")
);
const TeacherJourneyProfile = lazy(() =>
  import("../pages/teacherJourney/TeacherProfile")
);
const TeacherProfilePreview = lazy(() =>
  import("../pages/teacherJourney/profile-preview")
);

const BlogDetail = lazy(() => import("../pages/Blog"));
const AboutPage = lazy(() => import("../pages/About"));
const PrivacyPage = lazy(() => import("../pages/Privacy"));
const ReturnRefundPage = lazy(() => import("../pages/Refund"));
const TermsConditionsPage = lazy(() => import("../pages/TermsAndConditions"));
const ContactPage = lazy(() => import("../pages/Contact"));
const PaymentFailedPage = lazy(() => import("../pages/payment-failed"));
const PaymentSuccessPage = lazy(() => import("../pages/payment-success"));
const PaymentTestPage = lazy(() => import("../pages/payment-test"));
const WalletSummary = lazy(() => import("../pages/wallet"));
const UserSuccessCheckoutPage = lazy(() =>
  import("../pages/user-success-checkout-page")
);

const routeConfig = [
  // {
  //   path: `${Blog_url}`,
  //   component: BlogDetail,
  //   protected: "",
  // },
  {
    path: HOME_URL,
    component: Home,
    protected: "",
  },

  {
    path: "/un-authorized",
    component: UnAuthorized,
    protected: "",
  },

  {
    path: "/not-found",
    component: NotFound,
    protected: "",
  },
  // {
  //   path: SEARCH_URL,
  //   component: StudentsJourneyAdvanceFilter,
  //   protected: "",
  // },
  {
    path: "chat/:id",
    component: Chat,
    protected: "",
  },
  {
    path: Dynamo_URL,
    component: Dynamo,
    protected: "",
  },

  {
    path: `${About_url}`,
    component: AboutPage,
    protected: "",
  },

  {
    path: `${Contact_url}`,
    component: ContactPage,
    protected: "",
  },

  {
    path: `${Privacy_url}`,
    component: PrivacyPage,
    protected: "",
  },

  {
    path: `${ReturnRefund_url}`,
    component: ReturnRefundPage,
    protected: "",
  },

  {
    path: `${Terms_url}`,
    component: TermsConditionsPage,
    protected: "",
  },
  {
    path: `${PaymentFailed_url}`,
    component: PaymentFailedPage,
    protected: "",
  },
  {
    path: `${PaymentSuccess_url}`,
    component: PaymentSuccessPage,
    protected: "",
  },
  {
    path: `${PaymentTest_url}`,
    component: PaymentTestPage,
    protected: "",
  },
  {
    path: `${Blog_url}/:id`,
    component: BlogDetail,
    protected: "",
  },
];

const studentRouteConfig = [
  {
    path: `${STUENT_JOURNEY_URL}`,
    component: StudentMeetings,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/offers`,
    component: StudentOffers,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/messages`,
    component: StudentMessages,
    protected: "",
  },

  {
    path: `${About_url}`,
    component: AboutPage,
    protected: "",
  },

  {
    path: `${Contact_url}`,
    component: ContactPage,
    protected: "",
  },

  {
    path: `${Privacy_url}`,
    component: PrivacyPage,
    protected: "",
  },

  {
    path: `${Blog_url}/:id`,
    component: BlogDetail,
    protected: "",
  },

  {
    path: STUENT_JOURNEY_URL,
    component: StudentMyTeacher,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/session/:id`,
    component: StudentSession,
    protected: "",
  },
  // {
  //   path: `${STUENT_JOURNEY_URL}/findTeacher`,
  //   component: StudentsJourneyAdvanceFilter,
  //   protected: PROTECTED,
  // },
  {
    path: `${STUENT_JOURNEY_URL}/settings`,
    component: StudentProfileSetting,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/checkout-success`,
    component: UserSuccessCheckoutPage,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/wallet-summary`,
    component: WalletSummary,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/wallet-summary/payment-status`,
    component: PaymentSuccessPage,
    protected: "",
  },
];

const teacherRouteConfig = [
  {
    path: TEACHER_JOURNEY_URL,
    component: TeacherMeetings,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/profile-preview`,
    component: TeacherProfilePreview,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/messages`,
    component: TeacherMessages,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/offers`,
    component: TeacherOffers,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/teaching-board`,
    component: TeachingBoard,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/courses`,
    component: TeacherJourneyCourse,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/documents`,
    component: TeacherDocuments,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/education`,
    component: TeacherJourneyEducation,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/experience`,
    component: TeacherJourneyExperience,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/modeOfTeaching`,
    component: TeacherJourneyMode,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/slot`,
    component: TeacherJourneySlots,
    protected: "",
  },

  {
    path: `${About_url}`,
    component: AboutPage,
    protected: "",
  },

  {
    path: `${Contact_url}`,
    component: ContactPage,
    protected: "",
  },

  {
    path: `${Privacy_url}`,
    component: PrivacyPage,
    protected: "",
  },

  {
    path: `${Blog_url}/:id`,
    component: BlogDetail,
    protected: "",
  },
  // {
  //   path: `${TEACHER_JOURNEY_URL}/schedule`,
  //   component: TeacherJourneySchedule,
  //   protected: "",
  // },
  {
    path: `${TEACHER_JOURNEY_URL}/settings`,
    component: TeacherJourneyProfile,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/payment`,
    component: TeacherJourneyMemberShip,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/wallet-summary`,
    component: WalletSummary,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/checkout-success`,
    component: UserSuccessCheckoutPage,
    protected: "",
  },
];

const blogRouteConfig = [
  {
    path: `${Blog_url}`,
    component: BlogDetail,
    protected: "",
  },
];

// <Suspense
//   fallback={
//     currentUser?.role === "teacher" ? (
//       <SplachScreenTeacher />
//     ) : currentUser?.role === "student" ? (
//       <SplachScreenStudent />
//     ) : (
//       <SplachScreen />
//     )
//   }
// >
//   <Routes>
//     {routeConfig.map((route, index) => {
//       return (
//         <Route
//           exact
//           key={index}
//           path={route.path}
//           element={<route.component />}
//         />
//       );
//     })}
//     {/* <Route exact path="/not-found" element={<NotFound />} /> */}
//     <Route exact path="/*" element={<NotFound />} />
//   </Routes>
// </Suspense>

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<SplachScreen />}>
        {routeConfig.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}
      </Route>
      <Route element={<SplachScreenStudent />}>
        {studentRouteConfig.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}
      </Route>
      <Route element={<SplachScreenTeacher />}>
        {teacherRouteConfig.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}
      </Route>
      <Route element={<SplachScreenTeacher />}>
        {teacherRouteConfig.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}
      </Route>
      {/* <Route element={<SplachScreen />}>
        {blogRouteConfig.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}
      </Route> */}

      <Route element={<SplachScreenTeacher />}>
        <Route path={`${Blog_url}/:id`} element={<BlogDetail />} />
      </Route>

      <Route element={<SplachScreenTeacher />}>
        <Route path={`${About_url}`} element={<AboutPage />} />
      </Route>

      <Route element={<SplachScreenTeacher />}>
        <Route path={`${Privacy_url}`} element={<PrivacyPage />} />
      </Route>

      <Route element={<SplachScreenTeacher />}>
        <Route path={`${Terms_url}`} element={<TermsConditionsPage />} />
      </Route>

      <Route element={<SplachScreenTeacher />}>
        <Route path={`${ReturnRefund_url}`} element={<ReturnRefundPage />} />
      </Route>

      <Route element={<SplachScreenTeacher />}>
        <Route path={`${Contact_url}`} element={<ContactPage />} />
      </Route>

      <Route
        path="/student/findTeacher"
        element={<StudentsJourneyAdvanceFilter />}
      />

      <Route path={SEARCH_URL} element={<StudentsJourneyAdvanceFilter />} />
      <Route exact path="/*" element={<NotFound />} />
    </>
  )
);

export default router;
